import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

/**
 * Resolves ISO country codes to localized display names via the `countries` namespace.
 * Memoized for stable reference in dependent `useMemo` hooks; codes are normalized to
 * lowercase to match keys in public/locale/countries.json.
 */
export function useCountryDisplayName() {
  const { t } = useTranslation('countries')

  return useCallback(
    (code: string) => {
      const trimmed = code.trim()
      if (!trimmed) {
        return trimmed
      }
      const normalized = trimmed.toLowerCase()
      return t(normalized) || trimmed
    },
    [t]
  )
}
